export const CLICK_TO_FILTER_NOT_USED_VALUE = '';

export const RELATIONS = {
    EQUAL: '=',
    NOT_EQUAL: '!=',
    MORE: '>',
    LESS: '<',
    MORE_OR_EQUAL: '>=',
    LESS_OR_EQUAL: '<=',
    IS_NULL: 'is null',
    IS_NOT_NULL: 'is NOT null',
    EXISTS: 'exists',
    NOT_EXISTS: 'NOT exists',
    IS_ONE_OF: 'is one of',
    IS_NOT_ONE_OF: 'is NOT one of',
    IS_SUBNODE_OF: 'is subnode of',
    IS_NOT_SUBNODE_OF: 'is NOT subnode of',
    LIKE: 'like',
    NOT_LIKE: 'not like',
    REQUIRE_VALUE: 'require value',
    IGNORE: 'ignore'
};

export const RELATION_VALUES: { [attributeType: string]: string[] } = {
    s: [
        RELATIONS.EQUAL,
        RELATIONS.NOT_EQUAL,
        RELATIONS.MORE,
        RELATIONS.LESS,
        RELATIONS.MORE_OR_EQUAL,
        RELATIONS.LESS_OR_EQUAL,
        RELATIONS.IS_NULL,
        RELATIONS.IS_NOT_NULL,
        RELATIONS.EXISTS,
        RELATIONS.NOT_EXISTS,
        RELATIONS.LIKE,
        RELATIONS.NOT_LIKE,
        RELATIONS.IS_ONE_OF,
        RELATIONS.IS_NOT_ONE_OF
    ],

    i: [
        RELATIONS.EQUAL,
        RELATIONS.NOT_EQUAL,
        RELATIONS.MORE,
        RELATIONS.LESS,
        RELATIONS.MORE_OR_EQUAL,
        RELATIONS.LESS_OR_EQUAL,
        RELATIONS.IS_NULL,
        RELATIONS.IS_NOT_NULL,
        RELATIONS.EXISTS,
        RELATIONS.NOT_EXISTS
    ],

    r: [
        RELATIONS.EQUAL,
        RELATIONS.NOT_EQUAL,
        RELATIONS.MORE,
        RELATIONS.LESS,
        RELATIONS.MORE_OR_EQUAL,
        RELATIONS.LESS_OR_EQUAL,
        RELATIONS.IS_NULL,
        RELATIONS.IS_NOT_NULL,
        RELATIONS.EXISTS,
        RELATIONS.NOT_EXISTS
    ],

    b: [
        RELATIONS.EQUAL,
        RELATIONS.NOT_EQUAL,
        RELATIONS.IS_NULL,
        RELATIONS.IS_NOT_NULL,
        RELATIONS.EXISTS,
        RELATIONS.NOT_EXISTS
    ],

    date: [
        RELATIONS.EQUAL,
        RELATIONS.NOT_EQUAL,
        RELATIONS.MORE,
        RELATIONS.LESS,
        RELATIONS.MORE_OR_EQUAL,
        RELATIONS.LESS_OR_EQUAL,
        RELATIONS.IS_NULL,
        RELATIONS.IS_NOT_NULL,
        RELATIONS.EXISTS,
        RELATIONS.NOT_EXISTS
    ],

    datetime: [
        RELATIONS.EQUAL,
        RELATIONS.NOT_EQUAL,
        RELATIONS.MORE,
        RELATIONS.LESS,
        RELATIONS.MORE_OR_EQUAL,
        RELATIONS.LESS_OR_EQUAL,
        RELATIONS.IS_NULL,
        RELATIONS.IS_NOT_NULL,
        RELATIONS.EXISTS,
        RELATIONS.NOT_EXISTS
    ],

    time: [
        RELATIONS.EQUAL,
        RELATIONS.NOT_EQUAL,
        RELATIONS.MORE,
        RELATIONS.LESS,
        RELATIONS.MORE_OR_EQUAL,
        RELATIONS.LESS_OR_EQUAL,
        RELATIONS.IS_NULL,
        RELATIONS.IS_NOT_NULL,
        RELATIONS.EXISTS,
        RELATIONS.NOT_EXISTS
    ],

    e: [RELATIONS.IS_ONE_OF, RELATIONS.IS_NOT_ONE_OF, RELATIONS.IS_SUBNODE_OF, RELATIONS.IS_NOT_SUBNODE_OF],

    functionParameter: [RELATIONS.EQUAL],

    logical: [RELATIONS.EQUAL],

    anytype: [RELATIONS.IS_NULL, RELATIONS.IS_NOT_NULL, RELATIONS.EXISTS, RELATIONS.NOT_EXISTS]
};

export const VARIABLE_PERIOD_START = '@PeriodStart';
export const VARIABLE_PERIOD_END = '@PeriodEnd';
export const VARIABLE_USER_ID = '@UserID';
export const VARIABLE_FISCAL_MONTH = '@FiscalMonth';
export const VARIABLE_NULL = '@NULL';

export const URL_KEYS = {
    Datasource: 'datasource',
    TabTitle: 'tabTitle',
    KeepFilters: 'keepFilters',
    PeriodFrom: '@PeriodFrom', //EVG 08.10.24: Obsolete.
    PeriodTo: '@PeriodTo', //EVG 08.10.24: Obsolete.
    PeriodStart: VARIABLE_PERIOD_START,
    PeriodEnd: VARIABLE_PERIOD_END,
    OneDayPeriod: '@OneDayPeriod',
    FiscalMonth: VARIABLE_FISCAL_MONTH,
    Month: '@month',
    Quarter: '@quarter',
    Year: '@year',
    Expression: 'Exp:',
    TimePart: 'TimePart:',
    AttributeWithVariable: ':A@:',
    Type: ':Type:'
};

export const filtersThemeFields = {
    titlePosition: 'attribute-filter-title-position',
    showClickToFilterAttributes: 'show-click-to-filter-attributes'
};